import { FC } from 'react';
import { Skill } from '../../models/Skill';

/** Skills can carry a long tail of standards; the design shows the first few and counts the rest. */
const VISIBLE_BADGES = 3;

interface Props {
  standards: Skill['standards'];
  /** Ids of the standards selected in the filter; undefined is the neutral "All" state. */
  selectedStandardIds?: string[];
}

const SingleUnitStandardBadges: FC<Props> = ({ standards, selectedStandardIds }) => {
  const named = (standards ?? []).filter(standard => standard?.shortName);
  if (!named.length) return null;

  // Matching badges lead, so a teacher can see at a glance why the skill survived the filter — and so
  // the ones that survive the cap below are the ones that explain the current filter.
  const isSelected = (id: string) => !!selectedStandardIds?.includes(id);
  const ordered = [...named].sort((a, b) => Number(isSelected(b.id)) - Number(isSelected(a.id)));
  const visible = ordered.slice(0, VISIBLE_BADGES);
  const hiddenCount = ordered.length - visible.length;

  return (
    <span className="nc_unit-standard-badges">
      {visible.map(standard => (
        <span
          key={standard.id}
          className={`nc_unit-standard-badge${isSelected(standard.id) ? ' nc_unit-standard-badge-selected' : ''}`}
        >
          {standard.shortName}
        </span>
      ))}
      {hiddenCount > 0 && (
        <span
          className="nc_unit-standard-badge"
          title={ordered
            .slice(VISIBLE_BADGES)
            .map(standard => standard?.shortName)
            .join(', ')}
        >
          +{hiddenCount}
        </span>
      )}
    </span>
  );
};

export default SingleUnitStandardBadges;
